import { TranslateService } from '@ngx-translate/core';
import { Device } from '@capacitor/device';
import { Languages, LOCAL_STORAGE_LANG, LOCAL_STORAGE_LANG_CHANGED } from './language';

const SUPPORTED = Object.values(Languages);
const FALLBACK = Languages.EN;

async function detectDeviceLanguage(): Promise<string> {
  try {
    const info = await Device.getLanguageCode();
    return info.value;
  } catch {
    return navigator.languages?.[0] ?? navigator.language ?? 'en';
  }
}

export async function initLanguage(translate: TranslateService): Promise<void> {
  translate.addLangs(SUPPORTED);

  const saved = localStorage.getItem(LOCAL_STORAGE_LANG);
  const userChanged = localStorage.getItem(LOCAL_STORAGE_LANG_CHANGED) === 'true';

  let chosen: Languages;

  if (saved && userChanged && SUPPORTED.includes(saved as Languages)) {
    chosen = saved as Languages;
  } else {
    const deviceLang = (await detectDeviceLanguage()).split('-')[0];
    chosen = SUPPORTED.includes(deviceLang as Languages) ? (deviceLang as Languages) : FALLBACK;
  }

  translate.setFallbackLang(chosen);
  translate.use(chosen);
  localStorage.setItem(LOCAL_STORAGE_LANG, chosen);

  translate.onLangChange.subscribe(({ lang }) => {
    document.documentElement.lang = lang;
    localStorage.setItem(LOCAL_STORAGE_LANG, lang);
  });
}
